export const APP_CONFIG_LOCAL_STORAGE_TTL = 15;
export const APP_CONFIG_UPDATED_TIME = "appConfigUpdatedTime";
export const IS_ADS_ENABLED = "isAdsEnabled";
export const IS_JC_ENABLED = "isJobContainerEnabled";
export const IS_ATOZ_ENABLED = "isAtoZEnabled";
export const HIDE_ATOZ_TASK = "hideAtoZTask";
